import Vue from 'vue'
import CKEditor from 'ckeditor4-vue';


Vue.use(CKEditor)



// WEBPACK FOOTER //
// ./src/plugins/ckeditor.js